export function DisputesToolbar() {
  return (
    <div className="mb-2 flex flex-wrap items-center justify-between space-y-2">
      <div>
        <h2 className="font-bold text-2xl tracking-tight">ຂໍ້ພິພາດ</h2>
        <p className="text-muted-foreground text-sm">
          ດູຂໍ້ພິພາດອໍເດີ ແລະ ຕັດສິນ / ປະຕິເສດ
        </p>
      </div>
    </div>
  );
}
